'use client';

import { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useSettingsContext } from 'src/components/settings';

import { allLangs, defaultLang } from './config-lang';

export function useLocales() {
  const { i18n } = useTranslation();

  const currentLang = useMemo(
    () => allLangs.find((lang) => lang.value === i18n.language) || defaultLang,
    [i18n.language]
  );

  return {
    allLangs,
    currentLang,
  };
}

export function useTranslate() {
  const { t, i18n, ready } = useTranslation();
  const settings = useSettingsContext();

  const onChangeLang = useCallback(
    (newLang) => {
      i18n.changeLanguage(newLang);
      settings.onChangeDirectionByLang(newLang);
    },
    [i18n, settings]
  );

  return {
    t,
    ready,
    onChangeLang,
    currentLang: i18n.language,
  };
}
